module.exports = __webpack_public_path__ + "static/img/phone-vip-bg.510ba9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/phone-vip-bg.png
// module id = C2/u
// module chunks = 1